import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontMerriweather, fontRoboto, transientOptions } from "@product/scmp-sdk";

import { Checkbox } from "scmp-app/components/newsletter/newsletter-list/checkbox";

export const StyledCheckbox = styled(Checkbox)`
  grid-area: Checkbox;

  margin-inline-end: 12px;
`;

export const Summary = styled.div`
  grid-area: Summary;

  color: #001246;
  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: 14px;
  text-transform: uppercase;
`;

type PreviewContainerProps = {
  $isFocused?: boolean;
};
export const PreviewContainer = styled("div", { ...transientOptions })<PreviewContainerProps>`
  grid-area: Preview;

  justify-self: end;

  block-size: 14px;

  ${props => props.theme.breakpoints.up("tablet")} {
    ${props =>
      props.$isFocused &&
      css`
        display: none;
      `}
  }
`;

export const Title = styled.div`
  grid-area: Title;

  color: #001246;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 24px;

  ${props => props.theme.breakpoints.up("tablet")} {
    font-size: 21px;
    font-family: ${fontMerriweather};
    line-height: 27px;
  }
`;

export const Description = styled.div`
  grid-area: Description;

  margin-block-start: 8px;

  color: #2f3e68;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 18px;
`;

type ContainerProps = {
  $isFocused?: boolean;
};
export const Container = styled("div", { ...transientOptions })<ContainerProps>`
  display: grid;
  grid-template-areas:
    "Checkbox Summary Preview"
    "Checkbox Title Title"
    ". Description Description";
  grid-template-columns: min-content minmax(0, 1fr) minmax(0, 1fr);

  margin-block-end: 8px;
  padding: 16px;

  background: #f7f7f7;

  transition: transform 0.3s;
  animation: fadeIn 0.2s linear;
  ${props =>
    props.$isFocused &&
    css`
      background-color: #ecf3ff;
    `}
  ${props => props.theme.breakpoints.up("tablet")} {
    ${props =>
      props.$isFocused &&
      css`
        transform: translate3d(7px, 0, 0);
      `}
  }
`;
